// Quality flag marker: muted TriangleAlert with a tooltip listing the flags, or a pill per flag; never colour only.
import { TriangleAlertIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/cn";
import { CLAUSE_FLAG_LABELS, QUALITY_FLAG_LABELS } from "@/lib/labels";

const LABELS: Record<string, string> = { ...QUALITY_FLAG_LABELS, ...CLAUSE_FLAG_LABELS };

export function flagLabel(flag: string): string {
  return LABELS[flag] ?? flag.replaceAll("_", " ");
}

interface FlagBadgeProps {
  flags: readonly string[];
  variant?: "icon" | "pills";
  className?: string;
}

export function FlagBadge({ flags, variant = "icon", className }: FlagBadgeProps) {
  if (flags.length === 0) {
    return null;
  }
  if (variant === "pills") {
    return (
      <span className={cn("inline-flex flex-wrap gap-1", className)}>
        {flags.map((flag) => (
          <Badge key={flag} variant="grey">
            <TriangleAlertIcon aria-hidden />
            {flagLabel(flag)}
          </Badge>
        ))}
      </span>
    );
  }
  const text = flags.map(flagLabel).join(", ");
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={`Flagged: ${text}`}
          className={cn(
            "inline-flex size-[18px] items-center justify-center rounded-xs border-0 bg-transparent p-0 text-muted-foreground",
            className,
          )}
        >
          <TriangleAlertIcon aria-hidden className="size-[13px]" />
        </button>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  );
}
